export default __webpack_public_path__ + "assets/webgl/picking-22.4251268d.glb";